import PropTypes from 'prop-types';

export const Section = ({ className, children }) => {
  return (
    <div
      data-testid="section"
      className={`p-5 xl:px-0 lg:py-16 ${className ?? ''}`}
    >
      {children}
    </div>
  );
};

Section.propTypes = {
  className: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.object]).isRequired,
};
